import {
  type ActiveDexInfo,
  getActiveDexVersion,
  getDexInternalTooltip,
  isDexEnabled,
} from '@/utils/migration/dex-version';

import { useMe } from './use-me';

export type DexVersionInfo = ActiveDexInfo & {
  /** Tooltip text explaining version state for internal users */
  internalTooltip: string;
};

/**
 * Hook to get the active dex version info.
 * Uses the single source of truth from dex-version.ts
 */
export function useDexVersion(): DexVersionInfo | null {
  const me = useMe();
  const activeVersion = getActiveDexVersion(
    me.config.featureFlags,
    me.isInternal,
  );

  if (!activeVersion) {
    return null;
  }

  return {
    ...activeVersion,
    internalTooltip: getDexInternalTooltip(me.config.featureFlags, me.tenant),
  };
}

/**
 * Hook to check if any dex feature is enabled.
 */
export function useIsDexEnabled(): boolean {
  const me = useMe();
  return isDexEnabled(me.config.featureFlags, me.isInternal);
}
